import Vue from "vue";
import VueRouter from "vue-router";
import home from "../views/homeIndex.vue";
import work from "@/views/ez/work.vue";
import me from "@/views/ez/Sme.vue";
import release from "@/views/ez/release.vue";

import reg from "@/views/ez/reg.vue";
import store from "@/store/index.js";

import {
	Getitem
} from "../utils/item";

Vue.use(VueRouter);

const routes = [{
	path: "/",
	name: '/',
	component: home,
	children: [{
			path: "/work",
			name: 'work',
			component: work,
			children: [],
		},
		{
			path: "/me",
			component: me,
			children: [],
		},
		{
			path: "/reg",
			name: 'reg',
			component: reg,
			children: [],
		},
		{
			path: "/release",
			name: 'release',
			component: release,
			children: [],
		},
	],
}, ];

const router = new VueRouter({
	// mode: "history",
	// base: process.env.BASE_URL,
	routes,
});



export default router;